import * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssignSuccessorTaskRateSheetMutationVariables = Types.Exact<{
  rateSheetName: Types.Scalars['String'];
  effectiveDate: Types.Scalars['LocalDate'];
  projectNumbers: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type AssignSuccessorTaskRateSheetMutation = { __typename?: 'MutationModel', taskRates?: { __typename?: 'TaskRatesMutationModel', assignRateSheetToProject?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null } | null> | null } | null } | null };


export const AssignSuccessorTaskRateSheetDocument = gql`
    mutation AssignSuccessorTaskRateSheet($rateSheetName: String!, $effectiveDate: LocalDate!, $projectNumbers: [Int!]!) {
  taskRates {
    assignRateSheetToProject(
      rateSheetName: $rateSheetName
      effectiveDate: $effectiveDate
      projectNumbers: $projectNumbers
    ) {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type AssignSuccessorTaskRateSheetMutationFn = Apollo.MutationFunction<AssignSuccessorTaskRateSheetMutation, AssignSuccessorTaskRateSheetMutationVariables>;

/**
 * __useAssignSuccessorTaskRateSheetMutation__
 *
 * To run a mutation, you first call `useAssignSuccessorTaskRateSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignSuccessorTaskRateSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignSuccessorTaskRateSheetMutation, { data, loading, error }] = useAssignSuccessorTaskRateSheetMutation({
 *   variables: {
 *      rateSheetName: // value for 'rateSheetName'
 *      effectiveDate: // value for 'effectiveDate'
 *      projectNumbers: // value for 'projectNumbers'
 *   },
 * });
 */
export function useAssignSuccessorTaskRateSheetMutation(baseOptions?: Apollo.MutationHookOptions<AssignSuccessorTaskRateSheetMutation, AssignSuccessorTaskRateSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignSuccessorTaskRateSheetMutation, AssignSuccessorTaskRateSheetMutationVariables>(AssignSuccessorTaskRateSheetDocument, options);
      }
export type AssignSuccessorTaskRateSheetMutationHookResult = ReturnType<typeof useAssignSuccessorTaskRateSheetMutation>;
export type AssignSuccessorTaskRateSheetMutationResult = Apollo.MutationResult<AssignSuccessorTaskRateSheetMutation>;
export type AssignSuccessorTaskRateSheetMutationOptions = Apollo.BaseMutationOptions<AssignSuccessorTaskRateSheetMutation, AssignSuccessorTaskRateSheetMutationVariables>;